import React from 'react'
import styles from './styles.module.scss'
import singlePropertyTranslations from '../singlePropertyTranslation'

// Get default translations for fallbacks
const defaultTranslations = singlePropertyTranslations()

const ErrorDisplay = React.forwardRef(
  ({ error, translations, locale, paymentIntentId }, ref) => {
    if (!error) return null

    // Access Next.js environment variable (NEXT_PUBLIC_ prefix makes it available client-side)
    // ESLint: process.env is injected by Next.js at build time and is always available
    /* eslint-disable no-undef */
    const supportEmail =
      process.env.NEXT_PUBLIC_SUPPORT_EMAIL || 'reservations@sxmsir.com'
    /* eslint-enable no-undef */
    const subject = encodeURIComponent('Booking Assistance Needed')

    // Include payment intent ID in support email if available
    const bodyText = paymentIntentId
      ? `Hello,\n\nI need assistance with my booking.\n\nPayment Reference: ${paymentIntentId}\n\nPlease help me complete my reservation.\n\nThank you`
      : `Hello,\n\nI need assistance with my booking.\n\nPlease help me complete my reservation.\n\nThank you`

    const body = encodeURIComponent(bodyText)
    const mailtoLink = `mailto:${supportEmail}?subject=${subject}&body=${body}`

    return (
      <div
        ref={ref}
        className={styles.error_display}
        role="alert"
        aria-live="assertive"
        tabIndex={-1}
      >
        <div className={styles.error_display__header}>
          <div className={styles.error_display__icon} aria-hidden="true"></div>
          <h4 className={styles.error_display__title}>{error.title}</h4>
        </div>
        <div className={styles.error_display__content}>
          <p className={styles.error_display__message}>{error.message}</p>

          {/* Special message for reservation failure after payment success */}
          {error.type === 'reservation_failed' && error.paymentSucceeded && (
            <div className={styles.error_display__success_note}>
              <p className={styles.error_display__success_text}>
                {translations?.paymentSucceededNote?.[locale] ||
                  defaultTranslations.welcome.card.stripe.paymentSucceededNote[
                    locale
                  ] ||
                  defaultTranslations.welcome.card.stripe.paymentSucceededNote
                    .en}
              </p>
            </div>
          )}

          {/* Support contact for non-retryable errors */}
          {!error.canRetry && (
            <div className={styles.error_display__support}>
              <p className={styles.error_display__support_text}>
                {translations?.supportText?.[locale] ||
                  defaultTranslations.welcome.card.stripe.supportText[locale] ||
                  defaultTranslations.welcome.card.stripe.supportText.en}
              </p>
              {paymentIntentId && (
                <p className={styles.error_display__reference}>
                  {translations?.referenceId?.[locale] ||
                    defaultTranslations.welcome.card.stripe.referenceId?.[
                      locale
                    ] ||
                    defaultTranslations.welcome.card.stripe.referenceId?.en ||
                    'Reference ID'}
                  : <code>{paymentIntentId}</code>
                </p>
              )}
              <a
                href={mailtoLink}
                className={styles.error_display__support_link}
              >
                {supportEmail}
              </a>
            </div>
          )}
        </div>
      </div>
    )
  }
)

ErrorDisplay.displayName = 'ErrorDisplay'

export default ErrorDisplay
